module.exports = __webpack_public_path__ + "static2023-4-17/img/check_open.6f86d4be.jpg";